// API configuration with proper environment detection
// VERSION: 2025-10-26-v8 - Fixed debug page data guard
const BUILD_VERSION = '2025-10-26-v8-debug-guard-fix';

// Since you build locally and deploy, we'll rely on runtime detection
export const isProduction = window.location.hostname === 'admin.pagemind.ai' ||
                    window.location.hostname === 'pagemind.ai' ||
                    window.location.hostname === 'www.pagemind.ai';

export const isStaging = window.location.hostname.includes('staging') || 
                        window.location.hostname.includes('stage') ||
                        window.location.hostname === 'admin.staging.pagemind.ai';

// Check if we're in development mode with Vite dev server
const isDevelopment = import.meta.env.DEV;

// Base API URL - runtime detection takes precedence over build-time env vars
// For localhost, always use the local backend
export const API_BASE_URL = window.location.hostname === 'localhost' ? '' :
                           isProduction ? 'https://api.pagemind.ai' : 
                           isStaging ? 'https://api.staging.pagemind.ai' :
                           isDevelopment ? '' : // Use proxy in development
                           (import.meta.env.VITE_API_URL || ''); // Use same host in local Docker

// API URL with /api path - use proxy for local environments
export const API_URL = (!isProduction && !isStaging) ? '/api' : // Use proxy for all local environments
                      API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;

// Socket URL for real-time connections
// For local development, connect directly to backend on localhost:3001
// The WebSocket proxy in admin server has issues, so we bypass it for now
export const SOCKET_URL = isProduction ? 'https://api.pagemind.ai' :
                         isStaging ? 'https://api.staging.pagemind.ai' :
                         window.location.hostname === 'localhost' ? 'http://localhost:3001' : // Direct to backend from browser
                         isDevelopment ? 'http://localhost:3001' : // Direct to backend in dev
                         ''; // Use empty string for Docker environments

// Uploads URL - bypasses Cloudflare for large file uploads (up to 500MB)
// Uses direct connection to Hetzner load balancer
export const UPLOADS_URL = isProduction ? 'https://uploads.pagemind.ai/api' :
                          isStaging ? 'https://uploads.staging.pagemind.ai/api' :
                          '/api'; // Use proxy for local development

// Always log configuration for debugging
console.log('%c=== PAGEMIND API CONFIG ===', 'background: #222; color: #bada55; font-size: 16px; padding: 4px;');
console.log('[API Config] Build Version:', BUILD_VERSION);
console.log('[API Config] Hostname:', window.location.hostname);
console.log('[API Config] Is Production?:', isProduction);
console.log('[API Config] Is Staging?:', isStaging);
console.log('[API Config] VITE_API_URL:', import.meta.env.VITE_API_URL || 'not set');
console.log('[API Config] Final API_BASE_URL:', API_BASE_URL);
console.log('[API Config] Final API_URL:', API_URL);
console.log('[API Config] Final SOCKET_URL:', SOCKET_URL);
console.log('[API Config] Final UPLOADS_URL:', UPLOADS_URL);
console.log('%c=== END CONFIG ===', 'background: #222; color: #bada55; font-size: 16px; padding: 4px;');

// Research Service URL
export const RESEARCH_SERVICE_URL =
  import.meta.env.VITE_RESEARCH_SERVICE_URL ||
  (window.location.hostname === 'localhost' ? 'http://localhost:4010' : 'http://research-service:4010');

// Feature flags
export const PRIVATE_BETA_ENABLED = true; // Set to false to disable private beta features

export default {
  API_BASE_URL,
  API_URL,
  SOCKET_URL,
  UPLOADS_URL,
  RESEARCH_SERVICE_URL,
  isProduction,
  isStaging,
  PRIVATE_BETA_ENABLED
};